import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ItemsComponent } from './items.component';
import { ItemsListComponent } from './items-list/items-list.component';
import { ItemsCreateComponent } from './items-create/items-create.component';
import { ItemsDetailsComponent } from './items-details/items-details.component';
import { ItemsEditComponent } from './items-edit/items-edit.component';
import { ItemsSearchComponent } from './items-search/items-search.component';
import { ItemsByCategoriaComponent } from './items-by-categoria/items-by-categoria.component';
import { ItemSingleComponent } from './item-single/item-single.component';
import { ItemUploadImageComponent } from './item-upload-image/item-upload-image.component';


const routes: Routes = [{path: '', component: ItemsComponent, children: [
  {  path: '', 
  component:ItemsListComponent
},
  {  path: 'create', 
  component:ItemsCreateComponent
},
  {  path: 'details/:id', 
  component:ItemsDetailsComponent
},
  {  path: 'edit/:id', 
  component:ItemsEditComponent
},
  {  path: 'search', 
  component:ItemsSearchComponent
},
  {  path: 'byCategoria', 
 component:ItemsByCategoriaComponent
},

{  path: 'single/:id', 
 component:ItemSingleComponent
},
{  path: 'upload', 
 component:ItemUploadImageComponent
}
]}

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ItemsRoutingModule { }
